import { useRef } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons"
import { promotionsData } from "../data/PromotionData"

// Custom Arrow Components
const NextArrow = ({ onClick }) => (
  <button className="fgh-main-pagination-btn" onClick={onClick}>
    <FontAwesomeIcon icon={faChevronRight} className="custom-next-btn" />
  </button>
)

const PrevArrow = ({ onClick }) => (
  <button className="fgh-main-pagination-btn" onClick={onClick}>
    <FontAwesomeIcon icon={faChevronLeft} className="custom-next-btn" />
  </button>
)

const PromotionsList = () => {
  const sliderRef = useRef(null) // Reference to the Slider component

  // Create an array that interleaves real slides and spacer slides
  const slidesWithGaps = []
  promotionsData.forEach((promo, index) => {
    slidesWithGaps.push(promo) // Add the real slide
    slidesWithGaps.push({ id: `spacer-${index}`, isSpacer: true }) // Add the spacer slide
  })

  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false,
    variableWidth: true,
    cssEase: "ease-in-out",
    responsive: [
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          variableWidth: true,
          speed: 100,
        },
      },
    ],
  }

  return (
    <div>
      <div className="fgh-headlines-controls">
        <div className="fgh-headline-text" style={{ flexGrow: 1 }}>
          <h2 className="fgh-h2-style">Exclusive Promotions, Just for You</h2>
        </div>
        <div className="arrows-container">
          <PrevArrow onClick={() => sliderRef.current.slickPrev()} />
          <NextArrow onClick={() => sliderRef.current.slickNext()} />
        </div>
      </div>
      <Slider ref={sliderRef} {...settings}>
        {slidesWithGaps.map((slide) =>
          slide.isSpacer ? (
            <div key={slide.id} className="slick-slide fgh-spacer-slide" />
          ) : (
            // Wrap the slide content in an anchor tag to make the entire item clickable.
            // Here, slide.link is assumed to be the URL; if not present, we fallback to "#".
            <a
              key={slide.id}
              href={slide.tncLink || "#"}
              className="slick-slide promotionWrapper"
            >
              <div className="promotion-items-list">
                <img
                  src={slide.imgSrc}
                  className="promotionImage"
                  alt={slide.title}
                />
                <p className="promotionTitle">{slide.title}</p>
                <p className={`label-status label-${slide.status}`}>
                  {slide.status}
                </p>
              </div>
            </a>
          )
        )}
      </Slider>
    </div>
  )
}

export default PromotionsList
